import React, { useState } from 'react';
import { FilterableFieldList } from '../FilterableFieldList';
import { AppliedFilters } from '../AppliedFilters';
import { FieldValueSelector } from '../FieldValueSelector/FieldValueSelector';
import { IAppliedFilter, IFilterableField } from '../filters';
import { getDisplayFilterableFields } from './getDisplayFilterableFields';

type TFieldModalState = IFilterableField | undefined | 'choosing-the-field';

interface FilterModalContentProps {
  filterableFields: IFilterableField[];
  filters: IAppliedFilter[];
  onFiltersChanged: (newAppliedFilters: IAppliedFilter[]) => void;
}

export const FiltersModalContent = ({
  filterableFields,
  filters,
  onFiltersChanged,
}: FilterModalContentProps) => {
  const [currentFilterField, setCurrentFilterableField] =
    useState<TFieldModalState>();
  const handleAddFilter = (field: IFilterableField) => {
    setCurrentFilterableField(field);
  };
  const handleAddAnotherFilter = () => {
    setCurrentFilterableField('choosing-the-field');
  };
  const handleGoBack = () => {
    setCurrentFilterableField(undefined);
  };
  const hasAppliedFilters = filters.length > 0;
  const displayFields = getDisplayFilterableFields(filterableFields, filters);
  const onAppliedFilter = (filter: IAppliedFilter) => {
    onFiltersChanged([...filters, filter]);
    setCurrentFilterableField(undefined);
  };
  if (!currentFilterField && hasAppliedFilters) {
    return (
      <AppliedFilters
        filters={filters}
        onAppliedFiltersChanged={onFiltersChanged}
        onAddAnotherFilterClicked={handleAddAnotherFilter}
      />
    );
  }
  if (!currentFilterField || currentFilterField === 'choosing-the-field') {
    return (
      <FilterableFieldList
        hasAppliedFilters={hasAppliedFilters}
        onClickBack={handleGoBack}
        filterableFields={displayFields}
        onFieldClicked={handleAddFilter}
      />
    );
  }
  return (
    <FieldValueSelector
      field={currentFilterField as IFilterableField}
      onClickBack={handleGoBack}
      onAppliedFilter={onAppliedFilter}
    />
  );
};
